export default __webpack_public_path__ + "38ff5c4543ab48d12d556b6bf781c7f0.svg";